{
  "header": {
    "ariaLabel": "Lobby sections",
    "logoAlt": "BetBoss"
  },
  "tabs": {
    "ariaLabel": "Contests",
    "current": "Play",
    "history": "History"
  },
  "termsLink": "Terms & Conditions",
  "cards": {
    "currentAriaLabel": "Contests to play",
    "historyAriaLabel": "Past contests"
  },
  "empty": {
    "current": "No contests right now. Check back soon.",
    "currentWithHistory": "No contests right now. Your finished contests are under History.",
    "history": "Contests you entered show here for seven days after they finish."
  },
  "phaseLabels": {
    "opensSoon": "Opens Soon",
    "spinNow": "Spin Now",
    "placeBet": "Place a bet",
    "resume": "Resume",
    "viewPicks": "View Picks",
    "viewResults": "View Results",
    "contestClosed": "Contest Closed"
  },
  "phaseDetail": {
    "opensIn": "Opens in: {{remaining}}",
    "closesIn": "Closes in: {{remaining}}",
    "closesInUnknown": "Closes in: N/A",
    "contestClosed": "Entry window closed"
  },
  "winnerMessage": "🎉 YOU WON {{prize}}",
  "winnerRewardsDetail": "Rewards will land in your account within 24 hours"
}
